import { createContext, Dispatch, SetStateAction, useContext, useState } from 'react';

// ExpandedParamsCardContextType interface
interface ExpandedParamsCardContextType {
  // UI states
  isLoading: boolean;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
  isSpinnerReadingVisible: boolean;
  setIsSpinnerReadingVisible: Dispatch<SetStateAction<boolean>>;
  
  // Other states
  primerRender: boolean;
  setPrimerRender: Dispatch<SetStateAction<boolean>>;
}

// Create context with default values
export const ExpandedParamsCardContext = createContext<ExpandedParamsCardContextType>({} as ExpandedParamsCardContextType);

// useExpandedParamsCardContext
export const useExpandedParamsCardContext = () => {
  const context = useContext(ExpandedParamsCardContext);
  if (!context) {
    throw new Error('useExpandedParamsCardContext must be used within an ExpandedParamsCardProvider');
  }
  return context;
};

// ExpandedParamsCardProvider
export const ExpandedParamsCardProvider = ({ children, initialValue = {} }: any) => {
  // UI states
  const [isLoading, setIsLoading] = useState<boolean>(initialValue.isLoading || false);
  const [isSpinnerReadingVisible, setIsSpinnerReadingVisible] = useState<boolean>(initialValue.isSpinnerReadingVisible || false);
  
  // Other states
  const [primerRender, setPrimerRender] = useState<boolean>(initialValue.primerRender !== undefined ? initialValue.primerRender : true);
  const contextValue = {
    isLoading,
    setIsLoading,
    isSpinnerReadingVisible,
    setIsSpinnerReadingVisible,
    
    // Other states
    primerRender,
    setPrimerRender
  };

  return (
    <ExpandedParamsCardContext.Provider value={contextValue}>
      {children}
    </ExpandedParamsCardContext.Provider>
  );
};
